import { createStyles, Theme } from '@material-ui/core/styles'

export default (theme: Theme) => createStyles({
	paperLocations: {
		boxShadow: 'none',
		border: '1px solid #ebebeb',
		borderRadius: '0 0 5px 5px',
		borderTopWidth: 0,
		marginTop: -1,
	},
	labelIndustry: {
		color: theme.palette.grey[500],
		paddingLeft: 8,
		'&.MuiInputLabel-shrink': {
			marginTop: '-8px',
			paddingLeft: 0,
			fontSize: 20,
		}
	},
	inputBase: {
		color: theme.palette.grey[600],
	},
	labelText: {
		marginTop: '10px',
		marginBottom: '10px',
		fontSize: 16,
		color: theme.palette.grey[800]
	}
})
